// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line
import Vue from 'vue';
import moment from 'moment';
import App from './App';
import router from './router';
import axios from 'axios';
import { ACCESS_TYPE } from '@/constants';

// import wx from 'weixin-js-sdk';

// Vue.prototype.$wx = wx; // 挂载到Vue实例

axios.defaults.withCredentials = true;

axios.create({
	baseURL: '/ai-api',
	timeout: 50000
});

const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

try {
  let iconpath = 'https://cdn3.codesign.qq.com/icons/XzKaDZdEa7j2GPL/latest/iconfont.js';
  vhtml.Icon.setDefaultRemoteSrc && vhtml.Icon.setDefaultRemoteSrc(iconpath);
} catch (e) {
  console.log('load remote icon error');
}

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '汇信AI';
  if (to.name && window.$initType !== to.name) {
    window.location.reload();
  }
  next();
});

let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

webIMType = [5];
window.$initTypeKey = 5;
webIMSource = 'client';

Vue.prototype.webIMSource = webIMSource;

Object.defineProperty(window, 'userType', {
  writable: false,
  enumerable: false,
  configurable: false,
  value: 2
});

window.$initType = 'Chat';

// 企业微信环境判断
function isWorkWechat() {
  const UA = window.navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(UA) && /wxwork/i.test(UA);
}


// console.log('【init msg-------ACCESS_TYPE---->】', ACCESS_TYPE);
let tokenGet = webIMType.map(type => {
  return new Promise(async (resolve, reject) => {
    let Token = '';
    if (ACCESS_TYPE === 'ws') {
      const res = await axios.get('http://localhost:3000/getDemoToken');
      if (res && res.data && res.data.apiResponse && res.data.apiResponse.Token) {
        Token = res.data.apiResponse.Token;
      }
    }
    if (ACCESS_TYPE === 'sse') {
      // 获取链接上的参数code
      const urlParams = new URLSearchParams(window.location.search);
      const LinkCode = urlParams.get('code');
      const origin = process.env.HX_API_BASE_URL;
      if (isWorkWechat()) {
        // 企业微信环境
        console.log('企业微信环境')
        const WXCodeURL = `/ai-api/loginByWorkWechatCode`;
        const WXRes = await axios.post(WXCodeURL, {
          code: LinkCode
        })
        console.log('【init msg----------WXRes---->】', WXRes);
        if (WXRes && WXRes.data && WXRes.data.code === 200) {
          Token = WXRes.data.data;
          sessionStorage.setItem('AIToken', Token);
        }
      } else {
        // 企业BS环境
        console.log('非企业微信环境')
        window.addEventListener('message', function(event) {
          console.log('event.data', JSON.parse(event.data))
          const BSData = JSON.parse(event.data);
          if (BSData.type === 'BS_TOKEN') {
            const bsToken = BSData.bsToken;
            console.log('【init msg----------bsToken---->】', bsToken);
            if (bsToken) {
              const BSCodeURL = `/ai-api/loginByBsToken`;
              axios.post(BSCodeURL, {bsToken}).then(BSRes => {
                if (BSRes && BSRes.data && BSRes.data.code === 200) {
                  Token = BSRes.data.data;
                  sessionStorage.setItem('AIToken', Token);
                }
              }).catch(err => {
                console.log('【init msg----------err---->】', err);
              });
            } else {
              console.log('没有找到 token，请检查 sessionStorage');
            }
          }
        });
      }
    }
    let result = {
      type: type,
      token: Token,
      access: ACCESS_TYPE
    };
    // console.log('【init msg----------Token---->】', result);
    resolve(result);
  });
});

Promise.all(tokenGet).then(res => {
  console.log('【init msg----------res---->】', res);
  Object.defineProperty(window, 'webimToken', {
    writable: false,
    enumerable: false,
    configurable: false,
    value: res
  });
  if (ACCESS_TYPE === 'ws') {
    (async () => {
      let mixin = await import('@/manage/index');
      Vue.mixin(mixin);
      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        router,
        render(h) {
          return h(App);
        }
      }).$mount('#app');
    })();
  } else {
    (async () => {
      let sseMixin = await import('@/manage/sse');
      Vue.mixin(sseMixin);
      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        router,
        render(h) {
          return h(App);
        }
      }).$mount('#app');
    })();
  }
}).catch(e => {
});



// WEBPACK FOOTER //
// ./src/main.js